import { Col, InputNumber, Row } from "antd";

type TProps = {
    editing: boolean;
    intOff: number;
    intOn: number;
    setScheduleIntervalOnDays: (value: number) => void;
    setScheduleIntervalOffDays: (value: number) => void;
};

const ScheduleTypeIntervalSettings = ({
    editing,
    setScheduleIntervalOnDays,
    setScheduleIntervalOffDays,
    intOn,
    intOff
}: TProps): JSX.Element => {
    return (
        <Row className="vcentered">
            <Col className="full-width">
                <Row>
                    <label className="required">
                        Периодичность
                    </label>
                </Row>
                <Row className="vcentered">
                    <Col>
                        {editing ? (
                            <InputNumber
                                min={1}
                                max={14}
                                step={1}
                                value={intOn}
                                onChange={setScheduleIntervalOnDays}
                            />
                        ) : (
                            <span className="readonly">
                                {intOn}
                            </span>
                        )}
                    </Col>
                    <Col className="hpadded">
                        <span>д. через</span>
                    </Col>
                    <Col>
                        {editing ? (
                            <InputNumber
                                min={0}
                                max={14}
                                step={1}
                                value={intOff}
                                onChange={setScheduleIntervalOffDays}
                            />
                        ) : (
                            <span className="readonly">
                                {intOff}
                            </span>
                        )}
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export { ScheduleTypeIntervalSettings };